<div class="container-fluid text-pagination-total p-0">
  <div class="row">
    <ng-container *ngIf="pagination.collectionSize == 0; else elseTemplate">
      <div class="col-12 col-md-6 d-flex justify-content-center justify-content-lg-start">
        {{'PAGINATION.Pagination' | translate:({start: 0, end : 0, page : 0})}} 
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <div class="col-12 col-md-6 d-flex justify-content-center justify-content-lg-start">
        {{showingMessage(pagination)}}
      </div>
    </ng-template>
    <div class="col-12 col-md-6">
      <pagination class="d-flex justify-content-center justify-content-lg-end" [(ngModel)]="pagination.page"
        (pageChanged)="paginationOnChange($event)" [boundaryLinks]="true" [rotate]="true"
        [itemsPerPage]="pagination.pageSize" [totalItems]="pagination.collectionSize" [maxSize]="5"
        previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;">
      </pagination>
    </div>
  </div>
</div>
